import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFoxtelComponent } from './simple-icons-foxtel.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFoxtelComponent ],
    exports:      [ SimpleIconsFoxtelComponent ],
    bootstrap:    []
})
export class SimpleIconsFoxtelModule {}
